
import { useState, useEffect } from 'react';
import { canGetFortune, getTimeUntilNextFortune } from '../utils/cookieStorage';

export const useFortuneAvailability = () => {
  const [canUseFortune, setCanUseFortune] = useState<boolean>(true);
  const [nextFortuneTime, setNextFortuneTime] = useState<string>('');

  const checkFortuneAvailability = () => {
    console.log('Checking fortune availability');
    const canUse = canGetFortune();
    console.log('Can use fortune:', canUse);
    setCanUseFortune(canUse);
    setNextFortuneTime(getTimeUntilNextFortune());
  };

  useEffect(() => {
    checkFortuneAvailability();
    
    const interval = setInterval(() => {
      setNextFortuneTime(getTimeUntilNextFortune());
      checkFortuneAvailability();
    }, 60000);
    
    return () => clearInterval(interval);
  }, []);

  return {
    canUseFortune,
    nextFortuneTime,
    checkFortuneAvailability
  };
};
